const STORAGE_KEY = "report_progress_entries";

interface ProgressEntry {
  taskId: string;
  progress: number;
}

export const getProgressEntries = (): ProgressEntry[] => {
  const stored = localStorage.getItem(STORAGE_KEY);
  return stored ? JSON.parse(stored) : [];
};

export const setProgressEntries = (entries: ProgressEntry[]) => {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(entries));
};

export const updateOrAppendProgress = (taskId: string, progress: number) => {
  const current = getProgressEntries();
  const existingIndex = current.findIndex((entry) => entry.taskId === taskId);

  if (existingIndex !== -1) {
    current[existingIndex].progress = progress;
  } else {
    current.push({ taskId, progress });
  }

  setProgressEntries(current);
};

export const getStoredProgress = (taskId: string): number => {
  const entries = getProgressEntries();
  const entry = entries.find((e) => e.taskId === taskId);
  return entry?.progress ?? 0;
};

export const removeProgressEntry = (taskId: string) => {
  const entries = getProgressEntries();
  const updated = entries.filter((entry) => entry.taskId !== taskId);
  setProgressEntries(updated);
};

export const clearAllProgressEntries = () => {
  localStorage.removeItem(STORAGE_KEY);
};
